import { React, useState, useEffect, useRef, useContext } from "react";
import PCModal from "../PCModal";
import Button from "@mui/material/Button";
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import GridNoRow from '../../../common/GridNoRow';
import axios from "axios";
import Moment from 'moment';
import { AppContext } from '../../../AppStore';

function LotInfoModal({ title, id, onClose, lot_status_name, lot_save_name, lot_create_type_name, lot_create_datetime, lot_delete_type_name, lot_delete_datetime, item_type_name, item_division_name, item_name, item_spec, lot_plan_datetime, lot_loss_datetime }) {
  const appStore = useContext(AppContext);
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    id: true,
    item_lot_pre_status: false,
    item_lot_post_status: false,
    pre_status_name: true,
    post_status_name: true,
    item_lot_save_pre_workplace_id: false,
    item_lot_save_pre_warehouse_id: false,
    item_lot_save_pre_section_id: false,
    item_lot_save_pre_workplace_name: false,
    item_lot_save_pre_warehouse_name: false,
    item_lot_save_pre_section_name: false,
    item_lot_save_post_workplace_id: false,
    item_lot_save_post_warehouse_id: false,
    item_lot_save_post_section_id: false,
    item_lot_save_post_workplace_name: false,
    item_lot_save_post_warehouse_name: false,
    item_lot_save_post_section_name: false,
    log_data: true,
    reg_user_id: false,
    reg_user_name: true,
    reg_datetime: true
  });

  useEffect(() => {
      // Mount 될때만 실행된다.
      handleSetting();
      handleInitSelect();
  }, [])

  useEffect(() => {
      //렌더링 될 때 마다 실행된다.

  });

  const handleSetting = () => {
    setColumns([
      { field: 'id', headerName: '순번', width: 60, headerAlign: 'center', align:'right' },
      { field: 'item_lot_pre_status', headerName: 'item_lot_pre_status', width: 0, headerAlign: 'center' },
      { field: 'item_lot_post_status', headerName: 'item_lot_post_status', width: 0, headerAlign: 'center' },
      { field: 'pre_status_name', headerName: '변경 전', width: 70, headerAlign: 'center', align:'center' },
      { field: 'post_status_name', headerName: '변경 후', width: 70, headerAlign: 'center', align:'center' },
      { field: 'item_lot_save_pre_workplace_id', headerName: 'item_lot_save_pre_workplace_id', width: 0, headerAlign: 'center' },
      { field: 'item_lot_save_pre_warehouse_id', headerName: 'item_lot_save_pre_warehouse_id', width: 0, headerAlign: 'center' },
      { field: 'item_lot_save_pre_section_id', headerName: 'item_lot_save_pre_section_id', width: 0, headerAlign: 'center' },
      { field: 'item_lot_save_pre_workplace_name', headerName: 'item_lot_save_pre_workplace_name', width: 0, headerAlign: 'center' },
      { field: 'item_lot_save_pre_warehouse_name', headerName: 'item_lot_save_pre_warehouse_name', width: 0, headerAlign: 'center' },
      { field: 'item_lot_save_pre_section_name', headerName: 'item_lot_save_pre_section_name', width: 0, headerAlign: 'center' },
      { field: 'item_lot_save_post_workplace_id', headerName: 'item_lot_save_post_workplace_id', width: 0, headerAlign: 'center' },
      { field: 'item_lot_save_post_warehouse_id', headerName: 'item_lot_save_post_warehouse_id', width: 0, headerAlign: 'center' },
      { field: 'item_lot_save_post_section_id', headerName: 'item_lot_save_post_section_id', width: 0, headerAlign: 'center' },
      { field: 'item_lot_save_post_workplace_name', headerName: 'item_lot_save_post_workplace_name', width: 0, headerAlign: 'center' },
      { field: 'item_lot_save_post_warehouse_name', headerName: 'item_lot_save_post_warehouse_name', width: 0, headerAlign: 'center' },
      { field: 'item_lot_save_post_section_name', headerName: 'item_lot_save_post_section_name', width: 0, headerAlign: 'center' },
      { field: 'log_data', headerName: '이력', width: 420, headerAlign: 'center' },
      { field: 'reg_user_id', headerName: 'reg_user_id', width: 0, headerAlign: 'center', align:'center' },
      { field: 'reg_user_name', headerName: '등록자', width: 100, headerAlign: 'center', align:'center' },
      { field: 'reg_datetime', headerName: '등록일시', width: 160, headerAlign: 'center', align:'center' },
    ]);

    setColumnVisibilityModel({
      id: true,
      item_lot_pre_status: false,
      item_lot_post_status: false,
      pre_status_name: true,
      post_status_name: true,
      item_lot_save_pre_workplace_id: false,
      item_lot_save_pre_warehouse_id: false,
      item_lot_save_pre_section_id: false,
      item_lot_save_pre_workplace_name: false,
      item_lot_save_pre_warehouse_name: false,
      item_lot_save_pre_section_name: false,
      item_lot_save_post_workplace_id: false,
      item_lot_save_post_warehouse_id: false,
      item_lot_save_post_section_id: false,
      item_lot_save_post_workplace_name: false,
      item_lot_save_post_warehouse_name: false,
      item_lot_save_post_section_name: false,
      log_data: true,
      reg_user_id: false,
      reg_user_name: true,
      reg_datetime: true
    });
  }

  const handleInitSelect = () => {
    
    //조회
    axios.get('/api/p/LotInfo/LogList/'+id)
    .then((response) => {
        const array = response.data.map((item, index) => ({
          id: item.item_lotno_seq,
          item_lot_pre_status: item.item_lot_pre_status,
          item_lot_post_status: item.item_lot_post_status,
          pre_status_name: item.pre_status_name,
          post_status_name: item.post_status_name,
          item_lot_save_pre_workplace_id: item.item_lot_save_pre_workplace_id,
          item_lot_save_pre_warehouse_id: item.item_lot_save_pre_warehouse_id,
          item_lot_save_pre_section_id: item.item_lot_save_pre_section_id,
          item_lot_save_pre_workplace_name: item.item_lot_save_pre_workplace_name,
          item_lot_save_pre_warehouse_name: item.item_lot_save_pre_warehouse_name,
          item_lot_save_pre_section_name: item.item_lot_save_pre_section_name,
          item_lot_save_post_workplace_id: item.item_lot_save_post_workplace_id,
          item_lot_save_post_warehouse_id: item.item_lot_save_post_warehouse_id,
          item_lot_save_post_section_id: item.item_lot_save_post_section_id,
          item_lot_save_post_workplace_name: item.item_lot_save_post_workplace_name,
          item_lot_save_post_warehouse_name: item.item_lot_save_post_warehouse_name,
          item_lot_save_post_section_name: item.item_lot_save_post_section_name,
          log_data: item.log_data,
          reg_user_id: item.reg_user_id,
          reg_user_name: item.reg_user_name,
          reg_datetime: (item.reg_datetime === undefined?'':Moment(item.reg_datetime).format('YYYY-MM-DD HH:mm:ss')),
        }));
        setRows(array);
    })
    .catch((error) => {
      appStore.capture();
    });
  }

  return (
    <PCModal onClose={onClose} title={title}>
        <div className="modal" style={{ height: 'auto', overflowY: 'auto'}}>
          <div>
            <table className="ModalTABLE">
              <tbody>
                <tr>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">LotNo</div>
                      <div className="modal_filed_input" style={ { display:'flex' } }>
                       <input type="text" style={ { width: '175px', textAlign: 'center', backgroundColor: '#EFEFEF4D', fontWeight:'bold', color: 'black' } } value={id} name="id" autoComplete="off" readOnly />
                        &nbsp;&nbsp;
                        <input type="text" style={ { width: '65px', textAlign: 'center', backgroundColor: '#EFEFEF4D', fontWeight:'bold', color: 'black' } } value={lot_status_name} name="lot_status_name" autoComplete="off" readOnly />
                      </div>
                    </div>
                  </td>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">보관장소</div>
                      <div className="modal_filed_input">
                      <input type="text" style={ { width: '261px', backgroundColor: '#EFEFEF4D', fontWeight:'bold', color: 'black' } } value={lot_save_name} name="lot_save_name" autoComplete="off" readOnly />
                      </div>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">생성</div>
                      <div className="modal_filed_input" style={ { display:'flex' } }>
                       <input type="text" style={ { width: '65px', textAlign: 'center', backgroundColor: '#EFEFEF4D', fontWeight:'bold', color: 'black' } } value={lot_create_type_name} name="lot_create_type_name" autoComplete="off" readOnly />
                       &nbsp;&nbsp;
                       <input type="text" style={ { width: '175px', textAlign: 'center', backgroundColor: '#EFEFEF4D', fontWeight:'bold', color: 'black' } } value={lot_create_datetime} name="lot_create_datetime" autoComplete="off" readOnly />
                      </div>
                    </div>
                  </td>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">소멸</div>
                      <div className="modal_filed_input" style={ { display:'flex' } }>
                       <input type="text" style={ { width: '62px', textAlign: 'center', backgroundColor: '#EFEFEF4D', fontWeight:'bold', color: 'black' } } value={lot_delete_type_name} name="lot_delete_type_name" autoComplete="off" readOnly />
                       &nbsp;&nbsp;
                       <input type="text" style={ { width: '174px', textAlign: 'center', backgroundColor: '#EFEFEF4D', fontWeight:'bold', color: 'black' } } value={lot_delete_datetime} name="lot_delete_datetime" autoComplete="off" readOnly />
                      </div>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">계획</div>
                      <div className="modal_filed_input" style={ { display:'flex' } }>
                       {lot_plan_datetime !== ''?
                       <input type="text" style={ { width: '65px', textAlign: 'center', backgroundColor: '#EFEFEF4D', fontWeight:'bold', color: 'black' } } value={"계획"} autoComplete="off" readOnly />
                        : 
                       <input type="text" style={ { width: '65px', textAlign: 'center', backgroundColor: '#EFEFEF4D', fontWeight:'bold', color: 'black' } } value={""} autoComplete="off" readOnly />
                       }
                       &nbsp;&nbsp;
                       <input type="text" style={ { width: '175px', textAlign: 'center', backgroundColor: '#EFEFEF4D', fontWeight:'bold', color: 'black' } } value={lot_plan_datetime} name="lot_create_datetime" autoComplete="off" readOnly />
                      </div>
                    </div>
                  </td>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">분실</div>
                      <div className="modal_filed_input" style={ { display:'flex' } }>
                       {lot_loss_datetime !== ''?
                       <input type="text" style={ { width: '62px', textAlign: 'center', backgroundColor: '#EFEFEF4D', fontWeight:'bold', color: 'black' } } value={"분실"} autoComplete="off" readOnly />
                        : 
                       <input type="text" style={ { width: '65px', textAlign: 'center', backgroundColor: '#EFEFEF4D', fontWeight:'bold', color: 'black' } } value={""} autoComplete="off" readOnly />
                       }
                       &nbsp;&nbsp;
                       <input type="text" style={ { width: '174px', textAlign: 'center', backgroundColor: '#EFEFEF4D', fontWeight:'bold', color: 'black' } } value={lot_loss_datetime} name="lot_delete_datetime" autoComplete="off" readOnly />
                      </div>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className="ModalTD" colSpan={2}>
                    <div className="modal_filed">
                      <div className="modal_filed_title">품목</div>
                      <div className="modal_filed_input" style={ { display:'flex', width: '769px' } }>
                       <input type="text" style={ { width: '150px', backgroundColor: '#EFEFEF4D', fontWeight:'bold', color: 'black' } } value={item_name} name="item_name" autoComplete="off" readOnly />
                       &nbsp;&nbsp;
                       <input type="text" style={ { width: '80px', textAlign: 'center', backgroundColor: '#EFEFEF4D', fontWeight:'bold', color: 'black' } } value={item_type_name} name="item_type_name" autoComplete="off" readOnly />
                       &nbsp;&nbsp;
                       <input type="text" style={ { width: '120px', textAlign: 'center', backgroundColor: '#EFEFEF4D', fontWeight:'bold', color: 'black' } } value={item_division_name} name="item_division_name" autoComplete="off" readOnly />
                       &nbsp;&nbsp;
                       <input type="text" style={ { width: '450px', backgroundColor: '#EFEFEF4D', fontWeight:'bold', color: 'black' } } value={item_spec} name="item_spec" autoComplete="off" readOnly />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="ModalTD" colSpan={2}>
                    <div className="modal_grid" style={ { display:'block', height: '265px', paddingLeft: '0px', width: 'calc(100% - 50px)' } }>
                      <DataGrid
                        rows={rows}
                        columns={columns}
                        slots={{
                            noRowsOverlay: GridNoRow,
                        }}
                        columnVisibilityModel={columnVisibilityModel}
                        AlternatingRowBackground="LavenderBlush"
                        rowsPerPageOptions={[20, 50, 100]}
                        initialState={{ 
                            density: 'compact'
                        }}
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="ModalTD" colSpan={2}>
                    <div className="modal_action">
                      <div className="modal_button">
                        <Button 
                          onClick={()=> { onClose?.(); }}
                          className="btn-p"
                          sx={{  
                              m: 1, 
                              fontSize: 15, 
                              color: "white", 
                              borderColor: "#808080", 
                              backgroundColor: "#808080",
                              ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                          }} 
                          variant="outlined">
                          닫기
                        </Button>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
    </PCModal>
  );
}

export default LotInfoModal;